import {
  checkinSelectorFn,
  checkoutSelectorFn,
  countrySelectorFn,
  hotelsPartnerFn,
  roomStringSelectorFn,
} from '@stencil/hotels-common-reducer/src/selectors';
import {
  cityId as cityIdSelector,
  cityNameSelector,
  detailHttpCodeSelector,
  hasStaticDataSelector,
  hotelIdSelector,
} from '@stencil/hotels-details-reducer/src/selectors';
import allFirstLevelObjectKeysAreNonNullable from '@stencil/hotels-utils/src/all-first-level-object-keys-are-nullable';
import React from 'react';
import {useSelector} from 'react-redux';
import {createSelector} from 'reselect';
import makeSrpUrl from '../../../../../shared/utils/makeSrpUrl';
import WhatHappenedModal from '../WhatHappenedModal/WhatHappenedModal';

const defaultRedirectUrl = '/hotels/';

const voyagerStatusHandlerSelector = createSelector(
  [
    checkinSelectorFn,
    checkoutSelectorFn,
    roomStringSelectorFn,
    cityIdSelector,
    cityNameSelector,
    hotelsPartnerFn,
    countrySelectorFn,
  ],
  (checkinObj, checkoutObj, roomString, cityId, cityName, hotelsPartner, country) => ({
    checkinObj,
    checkoutObj,
    roomString,
    cityId,
    cityName,
    hotelsPartner,
    country,
  }),
);

const VoyagerStatusHandler = () => {
  const {
    checkinObj,
    checkoutObj,
    roomString,
    cityId,
    cityName,
    hotelsPartner,
    country,
  } = useSelector(voyagerStatusHandlerSelector);

  const voyagerStatus = useSelector(detailHttpCodeSelector);
  const hotelId = useSelector(hotelIdSelector);
  const hasStaticData = useSelector(hasStaticDataSelector);
  const noHotelId = !hotelId;

  const thereIsVoyagerError =
    hasStaticData && (voyagerStatus.startsWith('4') || voyagerStatus.startsWith('5') || !hotelId);

  const homePartner = useSelector(hotelsPartnerFn);
  const homePath = `/${homePartner}/`;

  const destination = {
    _id: cityId,
    n: cityName,
  };

  const srpMakingOptions = {
    checkin: checkinObj,
    checkout: checkoutObj,
    roomString,
    destination,
    partner: hotelsPartner,
    country,
  };

  let srpUrl = '';

  if (allFirstLevelObjectKeysAreNonNullable(srpMakingOptions) && cityName && cityId) {
    srpUrl = makeSrpUrl(srpMakingOptions);
  }

  const displayMessage = srpUrl ? `More Hotels in ${cityName}` : 'Home Page';

  let modalTitle = '';

  const somethingWentWront = 'Something Went Wrong';

  if (voyagerStatus === '410') {
    modalTitle = 'Hotel Is Currently Unavailable';
  } else {
    /**
     * this error message can be improved upon if we have an exhaustive list of all error codes and cases     from voyager
     */
    modalTitle = somethingWentWront;
  }

  if (noHotelId) {
    modalTitle = somethingWentWront;
  }

  let redirectUrl = homePath;

  if (srpUrl) {
    redirectUrl = srpUrl;
  }

  if (noHotelId) {
    redirectUrl = homePath;
  }

  if (!thereIsVoyagerError) {
    return null;
  }

  return (
    <WhatHappenedModal
      title={modalTitle}
      redirect={{
        shouldRedirect: true,
        to: redirectUrl || defaultRedirectUrl,
        after: 8,
        displayText: displayMessage,
      }}
    />
  );
};

export default VoyagerStatusHandler;
